import { Injectable } from "@angular/core";
import { JwtPayload } from "../models/JWT";

@Injectable({
    providedIn: "root"
})
export class JwtService {
    public get raw(): string | undefined {
        return localStorage.getItem("id_token") ?? undefined;
    }

    public get jwt(): JwtPayload | undefined {
        const raw = this.raw;

        if (raw == null) return undefined;
        return JSON.parse(atob(raw.split(".")[1])) as JwtPayload;
    }

    public set(val?: string) {
        if (val === undefined) localStorage.removeItem("id_token");
        else {
            if (val.startsWith("JWT ")) val = val.substring(4);
            if (val.startsWith("Bearer ")) val = val.substring(7);

            localStorage.setItem("id_token", val);
        }
    }
}
